import { parseToApiDate, prepareCoordinates } from '@repo/apg-ui';
import { SearchLocation } from '../store/search';
import { DateRange, SearchParameters } from '../store/search/types';

export const generateCriteria = (searchLocations: SearchLocation[], searchParams: SearchParameters) => {
  const newLocations = { ...searchLocations };
  let individualProductsId = '';

  const individualProducts =
    searchLocations &&
    Object.values(searchLocations)
      .filter(({ address }: any) => address && address.toLowerCase().includes('id:'))
      .map(({ product, address }: any) => {
        if (address) {
          individualProductsId += `-${address}`;
        }
        return product.producturn;
      });

  if (individualProductsId) {
    for (const locationsKey in newLocations) {
      const address = newLocations[locationsKey] ? newLocations[locationsKey].address : null;

      if (individualProductsId.includes(address)) {
        delete newLocations[locationsKey];
      }
    }
  }

  let searchurn = [];

  for (const locationKey of Object.keys(searchLocations)) {
    const location = searchLocations[locationKey];
    if (location.context !== 'address' && location.product) {
      searchurn.push(location.product.id);
      delete newLocations[locationKey];
    }

    if (location.context === 'postal_code') {
      const splittedAddress = location.address.split(' ');
      const zip = splittedAddress[0];
      searchurn.push(`google:zip:${zip}:${location.address}:${location.lngLtd.lng}:${location.lngLtd.lat}`);
      delete newLocations[locationKey];
    }
  }
  let criteria = {
    availability: {
      startdate: parseToApiDate(searchParams.dateRanges[0].startDate),
      duration: searchParams.duration,
    },
    timeslot: searchParams.timeslot,
    spotlength: searchParams.spotLength,
    industry: searchParams.industries || [],
    individualproducts: individualProducts || [],
    showNotAvailable: searchParams.isShowUnavailable,
    coordinate: prepareCoordinates(newLocations),
    format: [],
    target: [],
    attribute: [],
    commspace: [],
    searchurn: searchurn,
  };
  if (searchParams.isBudgetSelected) {
    criteria['budget'] = searchParams.budget;
  } else {
    criteria['frequency'] = searchParams.frequency;
  }
  return criteria;
};
